import { get } from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';

import Image from 'components/Image';
import Paragraph from 'components/Paragraph';
import Theme from 'styles/theme';

import { FONT_COLORS } from './constants';

const IMAGE_SIZE = 66;

const IconLandscapeCard = ({ paragraph, icon, textColor }) => (
  <div className="IconCard__wrapper">
    <Image
      src={get(icon, ['src'])}
      alt={get(icon, ['alt'])}
      className="IconCard__icon"
      transformations={{ width: IMAGE_SIZE }}
    />
    <Paragraph className="IconCard__body-text">{paragraph}</Paragraph>
    <style jsx>
      {`
        .IconCard__wrapper {
          height: 100%;
          width: 100%;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          padding: ${Theme.get('spacing') * 4}px ${Theme.get('spacing') * 8}px
            ${Theme.get('spacing') * 2}px;
        }
      `}
    </style>
    <style jsx global>
      {`
        .Paragraph.IconCard__body-text {
          color: ${Theme.get(`colors-${textColor}`)};
          text-align: center;
          margin-bottom: 0;
          font-size: 22px;
          overflow: hidden;
          width: 100%;
        }

        .IconCard__icon {
          margin-bottom: ${Theme.get('spacing') * 3}px;
        }
      `}
    </style>
  </div>
);

IconLandscapeCard.propTypes = {
  icon: PropTypes.shape({
    src: PropTypes.string.isRequired,
    alt: PropTypes.string.isRequired,
  }).isRequired,
  paragraph: PropTypes.string.isRequired,
  textColor: PropTypes.oneOf(Object.values(FONT_COLORS)).isRequired,
};

export default IconLandscapeCard;
